<script>
export default {
  components: {},
  data() {
    return {
      faqs: [
        {
          title: 'what is a Program? what is a Win?',
          text: `
            <p class="mb-1">Your daily <b><u>Program</u></b> is how you live each day. What is your daily routine, and does it all add up to improving your life? Or does it add up to a big bummer, bro?
            <p class="mb-2">Who do you aspire to be? Ok, great, you can talk the talk? But do you walk the walk? That's your Program.</p>
            <p class="mb-2">A <b><u>Win</u></b> is something you can do every day that results in a better life sooner or later. The obvious ones are like exercising, eating smart, learning new skills, and practicing self-discipline.</p>
            <p class="mb-1"><b>As you do each of these things today, you STACK a Win.</b> You either give yourself reasons to feel <b>PROUD</b> of yourself today...</p>
             <p class="mb-3">or you give yourself reasons to think less of yourself. <b>Make the right choice. STACK your Wins. Stack em high as a mf'er.</b></p>
              <p>"If a man is right, then his world will be right."</p>
              <p>"Your whole world can change, if only <i>You</i> will change."</p>
          `,
        },
        {
          title: 'what is MindMovie?',
          text: `
            <p class="mb-2">Imagine a movie of your life. what would it look like? what scenes would it include? what kind of character development? <b>play that movie in your mind over and over again, and wholeheartedly believe</b> that your life can and will look like that.</p>
            <p class="mb-2">If you do this with a true heart and mind, then you will begin to ack rite, and act like the main character of your MindMovie.</p>
            <p class="mb-2">After a while, you WILL be the main character of your MindMovie, because you have become him.</p>
            <p class="mt-5 mb-1"><b>Add pictures or videos to your Mind Movie.</b></p>
             <p class="mb-1">You must be signed in to use MindMovie.</p>
             <p class="mb-2">You can use Imgur posts or YouTube shorts. Go to "<a href="/account" class="text-blue-darken-1">My Account</a>" > click the "MindMovie" tab > click "Create a New Post".</p>
            <p class="mb-2">The header-nav (three horizontal lines in the top-right corner of the screen) contains a link to view your <a href="/mindmovie" class="text-blue-darken-1">Mind Movie</a>.</p>
          `
        },
        {
          title: 'what is a whatDo?',
          text: `
            <p>a whatDo is a simple way to start putting in WORK -> RIGHT NOW!</p>
            <p>we found infinite scrolling to be an irresponsible waste of our most precious resource: our life. we said we would rather invest our time into projects that enrich our lives and make it beautiful and worth living.</p>
            <p><b>so do them.</b> No more thumb-twiddling. Spin the wheel to randomly select what to work on — <i>whatDo</i></b>. </p>

            <p class="mt-5 mb-1"><b>if the whatDo wheel lands on something, but in your heart you want to work on another thing? <u>Good.</u></b> Do that. Now.</p>
             <p></p>
          `
        },
        {
          title: 'what is the wachamacallit?',
          text: `yurrrp, that's the whatsitwhosit`,
        },
      ],
    };
  },
  methods: {
    async goToCreateNewMindMoviePost() {
      await this.$cookies.set('lastViewedTab', 'mindMovie');
      this.$router.push('/account');
    },
  },
};
</script>

<template>


  <div id="page-faq" class="pa-3">
    <h1 id="h1-faqs">FAQs</h1>

    <!-- "send us a note" -->
    <div class="pt-3 pb-5">
      <p class="text-h6">Don't see your question answered below? <a href="#contact-form" class="text-blue-darken-1">Send us a note.</a></p>
    </div>

    <!-- faq's -->
    <div id="faqs" class="my-3">
      <v-expansion-panels>
        <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
          <v-expansion-panel-title>{{ faq.title }}</v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="mb-2" v-html="faq.text"></div>
          </v-expansion-panel-text>
        </v-expansion-panel>

      </v-expansion-panels>
    </div>


    <!-- contact form -->
    <div id="contact-form">
      <p>-- contact form coming soon --</p>
      <p><a href="#h1-faqs" class="text-blue-accent-3">back to top</a></p>
    </div>


  </div>
</template>
<style lang="scss" scoped>
#page-faq {
  padding-left: 16px;
  padding-right: 16px;
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 600px;
    margin: 0 auto
  }
}
#contact-form {
  margin-top: 800px;
  margin-bottom: 200px;
}
.v-expansion-panel-title__overlay {
  font-weight: bold !important;
}
</style>
